import React from "react";
import '../../pagesCSS/Projects.css';

const RentWell = () => {
  return (
    <div className='projectInfo'>
      <h2 className='projectTitle'>RentWell (Mar 2021)</h2>
      <ul className='projectBody'>
        <li>Allow user to post their apartment listing</li>
        <li>View apartment listings with email button as a point of contact</li>
        <li>Created services for Reset API Endpoints</li>
        <li>Used Firebase Authentication</li>
        <li>Practice Jetpack Navigation</li>
        <li>Technologies Used:</li>
          <ul>
            <li>Kotlin</li>
          </ul>
      </ul>
    </div>
  )
}

export default RentWell;